import { render, staticRenderFns } from "./TermSlidebar.vue?vue&type=template&id=1641b7a5"
import script from "./TermSlidebar.vue?vue&type=script&lang=js"
export * from "./TermSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports